import React, { useState } from "react";
import { Divider, Typography } from "@mui/material";
import { TextField } from "@mui/material";
import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@mui/material";

import "../../pages/styles/RuleEnrollment.css";

function DescriptionDialog({
  open,
  onClose,
  setRule_description,
  rule_description,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      className="guideline-dialog"
    >
      <DialogTitle variant="h6" onClose={onClose} className="dialog-title">
        Description
        {onClose ? <CloseIcon onClick={onClose} /> : null}
      </DialogTitle>
      <DialogContent>
        <hr className="hr-style" />
        <TextField
          id="outlined-multiline-static"
          label="Description"
          multiline
          rows={4}
          value={rule_description}
          onChange={(e) => setRule_description(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button
          className="ruleContainer d-table-cell tar"
          variant="contained"
          color="primary"
          onClick={onClose}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DescriptionDialog;
